import { render } from "./makimono_modal.vue?vue&type=template&id=1b6063d1&scoped=true"
import script from "./makimono_modal.vue?vue&type=script&lang=js"
export * from "./makimono_modal.vue?vue&type=script&lang=js"

import "./makimono_modal.vue?vue&type=style&index=0&id=1b6063d1&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6063d1"]])

export default __exports__